export const reportColumns = (t) => ({
  gridJourneyWork: [
    t("REPORT_COLUMNS.START"),
    t("REPORT_COLUMNS.START_LOCATION"),
    t("REPORT_COLUMNS.END"),
    t("REPORT_COLUMNS.END_LOCATION"),
    t("REPORT_COLUMNS.TOTAL_DISTANCE"),
    t("REPORT_COLUMNS.TRAVEL_TIME"),
    t("REPORT_COLUMNS.REST_TIME"),
    t("REPORT_COLUMNS.AVG_SPEED"),
    t("REPORT_COLUMNS.MAX_SPEED"),
    t("REPORT_COLUMNS.DRIVER"),
    t("REPORT_COLUMNS.PLATE"),
  ],
  gridTravelledDistance: [
    t("REPORT_COLUMNS.DISTANCE"),
    t("REPORT_COLUMNS.START"),
    t("REPORT_COLUMNS.START_LOCATION"),
    t("REPORT_COLUMNS.END"),
    t("REPORT_COLUMNS.END_LOCATION"),
  ],
  gridVehicleActivities: [
    t("REPORT_COLUMNS.DAY_OF_WEEK"),
    t("REPORT_COLUMNS.DATE"),
    t("REPORT_COLUMNS.DISTANCE"),
    t("REPORT_COLUMNS.IGNITION_ON"),
    t("REPORT_COLUMNS.ENGINE_TIME"),
    t("REPORT_COLUMNS.END"),
    t("REPORT_COLUMNS.SAMPLES_ABOVE_SPEED"),
    t("REPORT_COLUMNS.SAMPLES_WITHIN_SPEED"),
  ],
  gridVehiclePositions: [
    t("REPORT_COLUMNS.DATE_TIME"),
    t("REPORT_COLUMNS.STATUS"),
    t("REPORT_COLUMNS.IGNITION"),
    t("REPORT_COLUMNS.EVENT"),
    t("REPORT_COLUMNS.SPEED"),
    t("REPORT_COLUMNS.LOCATION"),
  ],
  gridPeriodVisits: [
    t("REPORT_COLUMNS.PLATE"),
    t("REPORT_COLUMNS.START"),
    t("REPORT_COLUMNS.DURATION"),
    t("REPORT_COLUMNS.TYPE"),
    t("REPORT_COLUMNS.LOCATION"),
  ],
  gridVisitAmount: [
    t("REPORT_COLUMNS.LOCATION"),
    t("REPORT_COLUMNS.START"),
    t("REPORT_COLUMNS.DURATION"),
    t("REPORT_COLUMNS.TYPE"),
    t("REPORT_COLUMNS.PLATE"),
  ],
  gridSpeedControl: [
    t("REPORT_COLUMNS.PLATE"),
    t("REPORT_COLUMNS.DATE_TIME"),
    t("REPORT_COLUMNS.SPEED"),
    t("REPORT_COLUMNS.LOCATION"),
  ],
  gridProtocols: [
    t("REPORT_COLUMNS.PROTOCOL"),
    t("REPORT_COLUMNS.PLATE"),
    t("REPORT_COLUMNS.STATUS"),
    t("REPORT_COLUMNS.DESCRIPTION"),
    t("REPORT_COLUMNS.OPENING_DATE"),
    t("REPORT_COLUMNS.SERVICE_DATE"),
    t("REPORT_COLUMNS.CLOSING_DATE"),
    t("REPORT_COLUMNS.ATTENDANT"),
  ],
  gridSystemLogs: [
    t("REPORT_COLUMNS.DATE_TIME"),
    t("REPORT_COLUMNS.TYPE"),
    t("REPORT_COLUMNS.ACCOUNT"),
    t("REPORT_COLUMNS.USER"),
    t("REPORT_COLUMNS.DESCRIPTION"),
  ],
});